import { Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FiltersComponentInterface, ViewDataService, WaHelperService } from 'world-archery-lib';
import { CountryCombo, DateFilterStore } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { GenericNewsStore } from 'src/app/common-page-components/stores/entities-store/generic-news-store';
import { TranslocoService } from '@ngneat/transloco';
import { FiltersAbstractService } from '../../../common-page-components/classes/filters-abstract-service';
import { TextFilter } from '../../../common-page-components/stores/filters-store/filters-store';
import { DisciplineComboStore, IndividualTeamComboStore } from 'src/app/common-page-components/stores/entities-store/continental-ranking.store';
import { WorldRankingCategoriesStore } from '../../../common-page-components/stores/entities-store/world-ranking.store';
import * as i0 from "@angular/core";
import * as i1 from "../../../library/wa-services/wa-helper-service";
import * as i2 from "../../../library/wa-services/view-data-service";
import * as i3 from "@angular/common/http";
import * as i4 from "@angular/router";
import * as i5 from "@ngneat/transloco";
export class WorldRankingFiltersService extends FiltersAbstractService {
    constructor(helper, views, http, router_nav, injector, router, translate_service) {
        super();
        this.helper = helper;
        this.views = views;
        this.http = http;
        this.router_nav = router_nav;
        this.injector = injector;
        this.router = router;
        this.translate_service = translate_service;
        /**
         * The news store for get the world ranking news.
         *
         * @memberof WorldRankingFiltersService
         */
        this.newsStore = new GenericNewsStore(this.http, environment.news_api.world_ranking);
        /**
         * The text filter.
         *
         * @memberof WorldRankingFiltersService
         */
        this.textFilter = new TextFilter('wrankingextfilter', undefined, undefined, 'search');
        /**
         * The country combo.
         *
         * @memberof WorldRankingFiltersService
         */
        this.countryCombo = new CountryCombo('Country:', 'countrycombo', this.http, [{ item: { CShort: 'All' }, position: 0 }], 'country', false);
        /**
         * The discipline combo.
         *
         * @memberof WorldRankingFiltersService
         */
        this.disciplineCombo = new DisciplineComboStore('Discipline:', 'world_ranking_discipline_combo');
        /**
         * The individual team combo.
         *
         * @memberof WorldRankingFiltersService
         */
        this.individualTeamCombo = new IndividualTeamComboStore('Event:', 'world_ranking-event-combo');
        /**
         * The categories combo.
         *
         * @memberof WorldRankingFiltersService
         */
        this.categoriesCombo = new WorldRankingCategoriesStore('world-ranking', 'Category:', this.http, this.injector);
        /**
         * The date filter.
         *
         * @memberof WorldRankingFiltersService
         */
        this.dateFilter = new DateFilterStore('continental-ranking-data', 'Date:', undefined, undefined, undefined, undefined, new Date(), 'date_from');
        /**
         * The filters used in view.
         *
         * @type {FiltersComponentInterface}
         * @memberof WorldRankingFiltersService
         */
        this.filtersType = [
            this.textFilter.filterInfo,
            this.disciplineCombo.filterInfo,
            this.individualTeamCombo.filterInfo,
            this.categoriesCombo.filterInfo,
            this.dateFilter.filterInfo,
            this.countryCombo.filterInfo,
        ];
        this.newsStore.requestData({}, false).subscribe();
        combineLatest([
            this.disciplineCombo.comboData,
        ]).pipe(tap(([discipline]) => this.categoriesCombo.requestData({
            'RBP': 'ALL',
            'ParaArchery': discipline.Value === true ? 1 : undefined
        }, false)
            .subscribe()))
            .subscribe();
    }
    /**
     * {@inheritdoc}
     *
     * @returns
     * @memberof WorldRankingFiltersService
     */
    getDataStreamWithFilters() {
        return combineLatest([
            this.orderValue,
            this.textFilter.data(300),
            this.categoriesCombo.comboData,
            this.dateFilter.data,
            this.disciplineCombo.comboData,
            this.countryCombo.comboData,
            this.individualTeamCombo.comboData,
        ]);
    }
    /**
     * {@inheritdoc}
     *
     * @memberof WorldRankingFiltersService
     */
    generateDefaultValues() {
    }
}
WorldRankingFiltersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WorldRankingFiltersService_Factory() { return new WorldRankingFiltersService(i0.ɵɵinject(i1.WaHelperService), i0.ɵɵinject(i2.ViewDataService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.Router), i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(i4.ActivatedRoute), i0.ɵɵinject(i5.TranslocoService)); }, token: WorldRankingFiltersService, providedIn: "root" });
